import React from 'react';

import Select from 'react-select';

import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectTypeRefData: React.FC<any> = ({ name, value, defaultValue, placeholder, handleChange, hasError, options, isDisabled }) => {
    return (
        <Select
            name={name}
            value={options.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={options}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectTypeRefData;
